import React, { useState } from "react";
import { UserProfileData } from "../../../../content/content";
import CommonModal from '../../../../component/model/ModelComponent'
import { IconButton, InputAdornment, Typography } from "@mui/material";
import CommonButton from "../../../../component/button/Button";
import { useTranslation } from "react-i18next";
import InputComponent from "../../../../component/input/Input";
import useForm from "../../../../hooks/useForm";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { updateCustomerPassword } from "../../../../services/customer-services/customerProfileService";
import Toast from "../../../../component/toastify/Index";
import "../../../../styles/pages/profile/profile.scss";

const initialValue = {
    password: "",
    confirmPassword: "",
    newPassword: ""
}

const CustomerChangePassword = ({ isModalOpen, setIsModalOpen }) => {
    const { t } = useTranslation();
    const [isPassword, setIsPassword] = useState(false);
    const [passwordVisibility, setPasswordVisibility] = useState({});
    const [passwordCriteria, setPasswordCriteria] = useState({
        length: false,
        uppercase: false,
        number: false,
        noSpaces: false,
    });

    const validateForm = (formData) => {
        const errors = {};

        UserProfileData?.Change_Password?.forEach((item) => {
            const fieldValue = formData[item.name];

            if (!fieldValue) {
                errors[item.name] = `${t(item.translationKey)} ${t("common_is_required")}`;
            }
        });

        if (formData.password) {
            if (!formData.confirmPassword) {
                errors["confirmPassword"] = `${t('common_label_confirm_password')} ${t("common_is_required")}`;
            } else if (formData.newPassword !== formData.confirmPassword) {
                errors["confirmPassword"] = `${t('common_label_password')} ${t('profile_is_do_not_match')}`;
            }
        }

        if (formData.confirmPassword) {
            if (!formData.password) {
                errors["password"] = `${t('common_label_password')} ${t("common_is_required")}`;
            }
            if (formData.newPassword !== formData.confirmPassword) {
                errors["confirmPassword"] = `${t('common_label_password')} ${t('profile_is_do_not_match')}`;
            }
        }

        return errors;
    };

    const { formData, errors, handleChange, handleSubmit, setFormData, setErrors, setIsSubmitted } = useForm(
        initialValue,
        validateForm,
        setPasswordCriteria,
        setIsPassword
    );

    const onSubmit = async () => {
        delete formData.confirmPassword
        const response = await updateCustomerPassword(formData);
        if (response?.isSuccess) {
            Toast(response.message, "success");
            onClose();
        } else {
            setFormData(initialValue);
            setErrors({});
            setIsPassword(false);
            setIsSubmitted(false);
            setPasswordVisibility({});
        }
    }

    const onClose = () => {
        setIsModalOpen(false);
        setFormData(initialValue);
        setErrors({});
        setIsPassword(false);
        setIsSubmitted(false);
        setPasswordVisibility({});
    }

    const togglePasswordVisibility = (fieldName) => {
        setPasswordVisibility((prevState) => ({
            ...prevState,
            [fieldName]: !prevState[fieldName],
        }));
    };

    return (
        <div>
            <CommonModal
                open={isModalOpen}
                onClose={onClose}
                title={t('profile_change_password')}
                className="model-title"
            >
                <Typography
                    className="user-model"
                    sx={{
                        border: "1px solid #E3E3E3",
                        padding: "20px",
                        borderRadius: "10px",
                    }}
                >
                    <form onSubmit={(e) => handleSubmit(e, onSubmit)} className="user-form">
                        {UserProfileData?.Change_Password?.map((item) => (
                            <>
                                <InputComponent
                                    type={
                                        passwordVisibility[item.name]
                                            ? "text"
                                            : "password"
                                    }
                                    borderColor="E3E3E3"
                                    border="2px solid #E3E3E3"
                                    padding="10px 12px"
                                    placeholder={t(item.placeholderTranslationKey)}
                                    label={t(item.translationKey)}
                                    className="user-input"
                                    name={item.name}
                                    value={formData[item.name] || ""}
                                    onChange={handleChange}
                                    required
                                    error={!!errors[item.name]}
                                    helperText={errors[item.name]}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => togglePasswordVisibility(item.name)}
                                                >
                                                    {passwordVisibility[item.name] ? (
                                                        <VisibilityOff />
                                                    ) : (
                                                        <Visibility />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                {item.name == "newPassword" && <Typography className='password-validation' sx={{ display: !isPassword && "none", paddingTop: "10px" }}>
                                    <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.length ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                        {passwordCriteria.length ? (
                                            <CheckIcon
                                                style={{ color: 'green', marginRight: '8px' }}
                                            />
                                        ) : (
                                            <CloseIcon
                                                style={{ color: '#d32f2f', marginRight: '8px' }}
                                            />
                                        )}
                                        {t('common_text_8_characters')}
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.uppercase ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                        {passwordCriteria.uppercase ? (
                                            <CheckIcon
                                                style={{ color: 'green', marginRight: '8px' }}
                                            />
                                        ) : (
                                            <CloseIcon
                                                style={{ color: '#d32f2f', marginRight: '8px' }}
                                            />
                                        )}
                                        {t('common_text_1_uppercase')}
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.number ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                        {passwordCriteria.number ? (
                                            <CheckIcon
                                                style={{ color: 'green', marginRight: '8px' }}
                                            />
                                        ) : (
                                            <CloseIcon
                                                style={{ color: '#d32f2f', marginRight: '8px' }}
                                            />
                                        )}
                                        {t('common_text_1_number')}
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.noSpaces ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                        {passwordCriteria.noSpaces ? (
                                            <CheckIcon
                                                style={{ color: 'green', marginRight: '8px' }}
                                            />
                                        ) : (
                                            <CloseIcon
                                                style={{ color: '#d32f2f', marginRight: '8px' }}
                                            />
                                        )}
                                        {t('common_text_no_space')}
                                    </p>
                                </Typography>
                                }
                            </>
                        ))}
                        <Typography className="model-action-btn">
                            <CommonButton
                                text={t("payment_status_cancel")}
                                className="invitation-btn"
                                bgColor="linear-gradient(90deg, #E14A4A 0%, #FF4848 100%);"
                                onClick={onClose}
                            />
                            <CommonButton
                                type="submit"
                                text={t('profile_change_password')}
                                className="add-user-btn change-password-btn"
                                bgColor="linear-gradient(90deg, #0075A4 0%, #009BD3 100%)"
                            />
                        </Typography>
                    </form>
                </Typography>
            </CommonModal>
        </div>
    )
}

export default CustomerChangePassword